import styled from 'styled-components';

export const Title = styled.h1`
  text-align: center;
  color: ${props => props.layout.colorText? props.layout.text : "#fff"};
  margin-bottom: 10px;
  font-size: 28px;
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

export const Subtitle = styled.p`
  text-align: center;
  color: ${props => props.layout.colorText? props.layout.text : "#fff"};
  margin-bottom: 30px;
  font-size: 16px;
  line-height: 1.5;
`;

export const InfoBox = styled.div`
  max-width: 750px;
  margin: 0 auto;
  background: ${props => props.layout?.primary_color ? `${props.layout.primary_color}15` : '#f8f9fa'};
  border: 1px solid ${props => props.layout?.primary_color ? `${props.layout.primary_color}40` : '#e1e5e9'};
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 25px;
  
  h3 {
    color: #333;
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 600;
  }
  
  p {
    color: #666;
    line-height: 1.6;
    margin-bottom: 8px;
    font-size: 14px;
  }
`;

export const FormSection = styled.div`
  margin-bottom: 25px;

  h1.userHeader {
    font-size: 20px;
    font-weight: 600;
    color: ${props => props.layout.colorText? props.layout.text : "#fff"};
    margin-bottom: 15px;
  }

  .midsize p {
    color: ${props => props.layout.colorText? props.layout.text : "#fff"};
  }
  
  h3 {
    color: ${props => props.layout.colorText? props.layout.text : "#fff"};
    font-size: 18px;
    padding-bottom: 8px;
  }

  textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid #707070;
    border-radius: 5px;
    font-size: 14px;
    resize: vertical;
    box-sizing: border-box;
    margin-top: 5px;
  }
`;

export const Required = styled.span`
  color: #e74c3c;
`;

export const CheckboxGroup = styled.div`
  margin: 25px 0;
  padding: 20px;
  background: #fff3e0;
  border-radius: 8px;
  border: 1px solid #ffcc80;
`;

export const CheckboxItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
  text-align: left;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  input[type="checkbox"] {
    margin-right: 12px;
    margin-top: 2px;
    transform: scale(1.2);
    width: 20px;
  }
  
  label {
    margin: 0;
    font-weight: normal;
    cursor: pointer;
  }
`;

export const WarningBox = styled.div`
  max-width: 750px;
  margin: 20px auto;
  background: #fff3cd;
  color: #856404;
  padding: 15px;
  border-radius: 6px;
  border: 1px solid #ffeaa7;
  font-size: 14px;
  
  strong {
    font-weight: 600;
  }
`;

export const ContactInfo = styled.div`
  max-width: 750px;
  margin: 30px auto;
  background: #e8f5e8;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #c3e6c3;
  
  h4 {
    color: #2d5016;
    margin-bottom: 10px;
    font-size: 16px;
  }
  
  p {
    color: #2d5016;
    margin-bottom: 5px;
    font-size: 14px;
  }
`;